import type { AuthServiceInterface } from '@acme/domains';
import { UserStatusEnum, useAuth, useUser } from '@acme/domains';
import { redirectTo } from '@shared/navigation';
import type { Certificate } from 'crypto-pro';
import { useNavigate } from 'react-router-dom';

interface UseAuthOptions {
  authService: AuthServiceInterface;
  onSuccessRedirect?: (userStatus?: UserStatusEnum) => void;
  onErrorRedirect?: (error: string) => void;
}

interface UseAuthReturn {
  auth: (
    selectedCertificate: Certificate,
    secret: any,
    password?: string,
    role?: any
  ) => Promise<void>;
  loading: boolean;
  error: string | null;
  remainingCountOfPasswordAttempts?: number | null;
}

export const useAuthWithRedirect = ({
  authService,
  onSuccessRedirect,
  onErrorRedirect,
}: UseAuthOptions): UseAuthReturn => {
  const { login } = useUser();
  const navigate = useNavigate();

  return useAuth({
    authService,
    login,
    onSuccessRedirect: (userStatus) => {
      if (onSuccessRedirect) {
        onSuccessRedirect(userStatus);
      } else {
        if (userStatus === UserStatusEnum.ExpectsChanges) {
          redirectTo('/profile');
        } else {
          redirectTo('/dashboard');
        }
      }
    },
    onErrorRedirect: (error) => {
      if (onErrorRedirect) {
        onErrorRedirect(error);
      } else {
        navigate('/auth/error', { state: { error } });
      }
    },
  });
};
